// Exports
export default {
	"container": "container_rxT7-",
	"withChatSection": "withChatSection_Q2Fzm",
	"wrapper": "wrapper_VhYfJ",
	"gratitudeHeader": "gratitudeHeader_PjnjD",
	"gratitudeDescription": "gratitudeDescription_ZMAbd",
	"chatHeader": "chatHeader_TGfm0",
	"chatDescription": "chatDescription_IrooW",
	"gratitudeSection": "gratitudeSection_jSXt1",
	"chatSection": "chatSection_Od4Zo",
	"imageWrapper": "imageWrapper_rrMfW",
	"chatContent": "chatContent_TE8u5",
	"chatJoinButton": "chatJoinButton_j2R9-"
};
